export default "__VITE_ASSET__2bIGLyjA__"